(function () {
  const KEY = "AIzaSyChq2PLmyqMQ0qz2QFJjdYj2MIc1FzHveo"; // TG key
  const { gmaps_geolocation, range } = window.store_locator;

  let waitTimesInterval;
  let map;
  let geocoder;
  let infoWindows = [];
  let locationElements = [];

  function isLocationFavorite(elem){
    const locationCard = elem.querySelector('.location')
    const locationName = elem.getAttribute("data-location") || locationCard.getAttribute("data-location")
    const favIcon = elem.querySelector('.fav-location');

    const logFavoriteStores = () => {
      console.log('Current Favourite Store:', localStorage.getItem('tg--webcheckin-fav'));
    };

    // Set active if favourite on first load
    const isFav = localStorage.getItem('tg--webcheckin-fav') === locationName;
    if (isFav) {
      elem.classList.add('is-fav', 'is-active');
    }

    // Function to toggle the favorite status
    const toggleFavorite = () => {
      // Recheck Favourite on toggle
      const isFav = localStorage.getItem('tg--webcheckin-fav') === locationName;

      // Remove "is-fav" class from all locations
      document.querySelectorAll('.is-fav').forEach(elem => elem.classList.remove('is-fav'))

      // Toggle Favourite
      if (!isFav) {
        localStorage.setItem('tg--webcheckin-fav', locationName);
        document.querySelectorAll('.is-active').forEach(elem => elem.classList.remove('is-active'))
        document.querySelectorAll(`.location[data-location="${locationName}"]`).forEach(e => e.classList.add("is-fav", "is-active"));
      } else {
        localStorage.setItem('tg--webcheckin-fav', undefined);
        document.querySelectorAll(`.location[data-location="${locationName}"]`).forEach(e => e.classList.remove("is-fav"));
      }
    }

    // Add a click event listener to the favorite button
    favIcon.addEventListener("click", () => {
      toggleFavorite();
      logFavoriteStores();
    });
  }

  function handleize(str) {
    return str
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, '') // Remove non-alphanumeric characters
    .replace(/\s+/g, '-')        // Replace spaces with hyphens
    .trim();
  }

  class Listing {
    constructor(store, { label = false, showDistance = false } = {}) {
      this.store = store;
      this.showDistance = showDistance;
      this.label = label;

      this.createElement();
    }

    async setWaitTime() {
      if (this.element && this.store.shortcut_id && this.store.store_toggle) {
        const container = this.element.querySelector(".js-wait-time");

        var checkBtn = ".CheckIn--" + `${this.store.guid}`;
        if (this.store.store_toggle) {
          const response = await fetch(
            `https://gft.tommyguns.com/api/v1/kiosk/GetShopStatus/${this.store.shortcut_id}`
          ).catch((error)=>{
            console.log("Fetch Error",error);
          });
          const {
            waitTime,
            shopStatus,
            upcomingOpenTime = "",
          } = await response.json();

          const storeClosed = Boolean(["Closed", "Full"].includes(shopStatus));
          let waitTimeHTML;

          this.element.querySelector(checkBtn).style.display = storeClosed
            ? "none"
            : "block";

          switch (shopStatus) {
          // var statustmp = 'Closed';
          // switch (statustmp) {
            case "Open":
              if (waitTime === 0) {
                waitTimeHTML = '<span class="wait-time__time">Serving Now</span>';
              } else {
                const time = new Number(waitTime);
                const hours = `0${Math.floor(time / 60)}`.slice(-2);
                const minutes = `0${time % 60}`.slice(-2);

                if (hours > 0) {
                  waitTimeHTML = `
                    <span class="wait-time__text">Estimated</span>
                    <span class="wait-time__time">${hours} Hr ${minutes} Min Wait</span>
                  `;
                } else {
                  waitTimeHTML = `
                    <span class="wait-time__text">Estimated</span>
                    <span class="wait-time__time">${minutes} Minute Wait</span>
                  `;
                }
              }
            break;
            case "Closed":
              waitTimeHTML = `
                <span class="wait-time__time">Closed</span>
                ${
                  upcomingOpenTime
                    ? `
                  <span class="wait-time__text wait-time__text--reopens">${upcomingOpenTime}</span>
                `
                    : ""
                }
              `;
              break;
            case "Full":
              waitTimeHTML = `
                <span class="wait-time__time">Full for the day</span>
                ${
                  upcomingOpenTime
                    ? `
                  <span class="wait-time__text wait-time__text--reopens">${upcomingOpenTime}</span>
                `
                    : ""
                }
              `;
              break;
            default:
              waitTimeHTML = `
                <span class="wait-time__time">${this.store.gftDefault}</span>
               `;
              this.element.querySelector(".normalLink.js-check-in").style.display = "none";
              this.element.querySelector(".modalLink.js-check-in").style.display = "none";
              break;
          }
          container.innerHTML = waitTimeHTML;
        } else {
          container.innerHTML = `
                  <span class="wait-time__text eventSubtitle">${this.store.eventSubtitle}</span>
                  <span class="wait-time__time">${this.store.eventTitle}</span>
          `;
          this.element.querySelectorAll(checkBtn).forEach((e)=>{e.style.display = "none"});
        }
      }
      /* Adds is-active to first location */
      const firstLocation = document.querySelector("ul.locations-nearest__list li:first-child");
      const hasIsFav = document.querySelector("ul.locations-nearest__list .is-fav");
      if (!hasIsFav) {
        if (firstLocation) {
            firstLocation.classList.add("is-active");
        }
      }
    }

    // initWaitTime() {
    //   this.setWaitTime();
    //   this.waitTimeInterval = setInterval(this.setWaitTime.bind(this), 60000);
    // }

    // clearWaitTime() {
    //   if (this.waitTimeInterval) {
    //     clearInterval(this.waitTimeInterval);
    //   }
    // }

    destroy() {
      this.element.remove();
      // this.clearWaitTime();

      if (this.label) {
        this.store.marker.setLabel("");
      }
    }

    createElement() {
      const element = document.createElement("LI");
      element.classList.add("location");
      element.setAttribute("data-location", handleize(this.store.name));

      element.innerHTML = `
        <div class="location-heading">
          <h2 class="location__title hard" data-location="${handleize(this.store.name)}">
            ${this.store.name}
          </h2>
            ${
              this.showDistance && this.store.distance
                ? `<span class="location__distance">${
                    Math.round(this.store.distance * 10) / 10
                  }km</span>`
                : ""}

                <div class="d-flex ml-auto ps-2">
                  <svg class="fav-location" xmlns="http://www.w3.org/2000/svg" height="28" width="28" viewBox="0 -960 960 960">
                    <path d="m480-120-58-52q-101-91-167-157T150-447.5Q111-500 95.5-544T80-634q0-94 63-157t157-63q52 0 99 22t81 62q34-40 81-62t99-22q94 0 157 63t63 157q0 46-15.5 90T810-447.5Q771-395 705-329T538-172l-58 52Z"/>
                  </svg>
                  <a
                    class=""
                    href="${this.store.maps_url}"
                    target="_blank"
                  >
                    <svg class="ml-2" xmlns="http://www.w3.org/2000/svg" height="28" width="28" viewBox="0 -960 960 960">
                      <path d="M480.184-486.043q31.077 0 52.707-21.532 21.631-21.531 21.631-52.609 0-31.077-21.649-52.707-21.649-21.631-52.891-21.631-31.243 0-52.591 21.649-21.348 21.649-21.348 52.891 0 31.243 21.532 52.591 21.531 21.348 52.609 21.348ZM480-170.305q130.174-117.608 192.543-210.739 62.37-93.13 62.37-172.652 0-114.809-73.794-188.013-73.794-73.204-181.034-73.204-107.241 0-181.119 73.204-73.879 73.204-73.879 188.013 0 79.522 63.87 172.37Q352.826-288.479 480-170.305Zm0 104.436Q312.217-206.826 229.043-325.456q-83.174-118.631-83.174-228.24 0-155.494 100.761-248.247Q347.392-894.696 480-894.696q132.366 0 233.531 92.753 101.165 92.753 101.165 248.247 0 109.609-83.456 228.24Q647.783-206.826 480-65.869ZM480-560Z" />
                    </svg>
                  </a>
                </div>
        </div>
        <div class="location__content">
          <div class="location__address" target="_blank">
            <address>
              ${this.store.short_address}
            </address>
          </div>
            <a href="tel:${
              this.store.phone_number
            }" class="location__phone">
              ${this.store.phone_number}
            </a>
          <div class="location__actions">

          <div class="wait-time__container">
            ${this.store.store_toggle !== false ? `
              <svg xmlns="http://www.w3.org/2000/svg" height="28" width="28" viewBox="1 -960 960 960">
                <path d="m620.782-284.739 54.609-53.479-156.173-157.303v-195.218h-72.436v224.749l174 181.251ZM480.078-65.869q-85.469 0-160.943-32.555-75.473-32.555-131.802-88.863-56.33-56.308-88.897-131.753-32.567-75.444-32.567-160.898 0-85.453 32.678-160.99 32.677-75.536 88.833-131.692 56.156-56.156 131.639-89.116T480-894.696q85.498 0 160.981 32.96 75.483 32.96 131.639 89.116 56.156 56.156 89.116 131.639T894.696-480q0 85.498-32.96 160.981-32.96 75.483-89.116 131.639-56.156 56.156-131.614 88.833-75.459 32.678-160.928 32.678ZM480-480Zm-.288 334.913q138.027 0 236.614-98.022 98.587-98.021 98.587-236.608t-98.512-236.892q-98.512-98.304-236.396-98.304-138.309 0-236.614 98.235Q145.087-618.444 145.087-480q0 138.87 98.299 236.891 98.3 98.022 236.326 98.022Z"/>
              </svg>
              <div class="wait-time js-wait-time"></div>
              ` :
              `
              <div class="store-details__wait-time wait-time">
								<span class="wait-time__text">${ this.store.toggle_title }</span>
								<span class="wait-time__time">${ this.store.toggle_sub_title }</span>
							</div>
              `}
          </div>
          <div class="location__buttons ">
            <a href="${this.store.url}" class="location__details btn btn--secondary">
              See details
            </a>

            ${this.store.check_in_disable === 'true' ? `
            <a
              href="tel:${this.store.phone_number}"
              class="modalLink btn btn--primary location__details"
              style="display: block !important;"
            >
            <svg class="icon icon--phone me-2 icons-google" width="22" height="22" fill="#fff" viewBox="0 -960 960 960" aria-hidden="true" focusable="false" role="presentation">
		        <path xmlns="http://www.w3.org/2000/svg" d="M795-113q-136-9-256.5-63T323-325q-95-94-148.5-215T112-797q-2-23 11.5-37.5T160-849h174q17 0 30 10.5t18 26.5l28 137q2 11-1.5 23t-9.5 18L293-526q19 35 43.5 68t56.5 65q29 28 60 52t63 41l115-108q7-7 14.5-9t16.5 0l147 33q17 5 28 17.5t11 29.5v176q0 23-15 36.5T795-113Z"></path>
		        <path d="M798-120q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12Z"></path></svg>
              Call to Check-In Now</a
            >
            ` :
            `
            <div class="${this.store.store_toggle !== false && this.store.check_in_url ? '' : ' hidden'}">
             <a
              href="/pages/check-in-qr-code"
              class="normalLink btn btn--primary location__check-in js-check-in webCheckIn">Check In</a>
             <a
              href="/pages/check-in-qr-code"
              class="modalLink btn btn--primary location__check-in js-check-in webCheckIn">Check In</a>
            </div>
            `}

          </div>

          </div>
        </div>
      `
      isLocationFavorite(element);
      ;

      element.addEventListener("click", (event) => {
        // Check if the clicked element or any of its ancestors are <a> tags
        if (event.target.closest('a') || event.target.closest('svg:not(.fav-location)')) {
          // If it's an <a> tag or its descendant, prevent the default behavior
          return;
        }
        map.focusStore(this.store);
      });

      // const modalLink = element.querySelector(".modalLink")
      // if (modalLink) {
      //   modalLink.addEventListener("click", () => {
      //     $("#checkinButton").attr("href", $(this).data("bs-url"));
      //       // Prevent the default action of the link
      //       event.preventDefault();

      //       // Get the data-url attribute from the clicked link
      //       const iframeUrl = checkInLink.getAttribute("data-url");

      //       // Get the checkin container
      //       const container = document.querySelector('div#checkInContainer');

      //       // Get the checkin Iframe
      //       const iframe = document.querySelector('iframe#checkInFrame');

      //       // Update the src attribute and make it visible
      //       iframe.setAttribute("src", iframeUrl);
      //       if (container.classList.contains('visible')) {
      //         container.classList.remove('visible');
      //         iframe.setAttribute("src", "about:blank");
      //       } else {
      //         container.classList.add('visible');
      //       }

      //     // }
      //   });
      // }

      // WEB Checkin
      // const checkInLink = element.querySelector(`.normalLink.location__check-in.js-check-in.webcheckin.CheckIn--${this.store.guid}`)
      // if (checkInLink) {
      //   checkInLink.addEventListener("click", ()=> {
      //     // Prevent the default action of the link
      //     event.preventDefault();

      //     // Get the data-url attribute from the clicked link
      //     const iframeUrl = checkInLink.getAttribute("data-url");

      //     // Get the checkin container
      //     const container = document.querySelector('div#checkInContainer');

      //     // Get the checkin Iframe
      //     const iframe = document.querySelector('iframe#checkInFrame');

      //     // Update the src attribute and make it visible
      //     iframe.setAttribute("src", iframeUrl);
      //     if (container.classList.contains('visible')) {
      //       //container.classList.remove('visible');
      //       //iframe.setAttribute("src", "about:blank");
      //     } else {
      //       container.classList.add('visible');
      //     }
      //   })
      // }

      this.element = element;
    }
  }

  class Store {
    constructor(data = {}) {
      // console.log(data);
      Object.entries(data).forEach(([key, value]) => {
        this[key] = value;
      });
    }

    getDistance(position) {
      const R = 6371; // Radius of the earth in km
      const convertToRad = (deg) => {
        return deg * (Math.PI / 180);
      };

      const distanceLat = convertToRad(this.location.lat - position.lat);
      const distanceLng = convertToRad(this.location.lng - position.lng);

      const a =
        Math.sin(distanceLat / 2) * Math.sin(distanceLat / 2) +
        Math.cos(convertToRad(position.lat)) *
          Math.cos(convertToRad(this.location.lat)) *
          Math.sin(distanceLng / 2) *
          Math.sin(distanceLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const d = R * c; // Distance in km

      return d;
    }

    async setWaitTime() {
      const container = document.getElementById(`WaitTime--${this.guid}`);

      if (container && this.shortcut_id) {
        var checkBtn = ".CheckIn--" + `${this.guid}`;
        if (this.locationToggle != "true") {
          const response = await fetch(
            `https://gft.tommyguns.com/api/v1/kiosk/GetShopStatus/${this.shortcut_id}`
          );
          const {
            waitTime,
            shopStatus,
            upcomingOpenTime = "",
          } = await response.json();

          const storeClosed = Boolean(
            ["Closed", "Full", undefined].includes(shopStatus)
          );
          let waitTimeHTML;

          switch (shopStatus) {
            case "Open":
              if (waitTime == 0) {
                waitTimeHTML =
                  '<span class="wait-time__time">Serving Now</span>';
              } else {
                const time = new Number(waitTime);
                const hours = `0${Math.floor(time / 60)}`.slice(-2);
                const minutes = `0${time % 60}`.slice(-2);

                if (hours > 0) {
                  waitTimeHTML = `
                    <span class="wait-time__text">Estimated</span>
                    <span class="wait-time__time">${hours} Hr ${minutes} Min Wait</span>
                  `;
                } else {
                  waitTimeHTML = `
                    <span class="wait-time__text">Estimated</span>
                    <span class="wait-time__time">${minutes} Minute Wait</span>
                  `;
                }
              }
              break;
            case "Closed":
              waitTimeHTML = `
                <span class="wait-time__time">Closed</span>
                ${
                  upcomingOpenTime
                    ? `
                  <span class="wait-time__text wait-time__text--reopens">${upcomingOpenTime}</span>
                `
                    : ""
                }
              `;
              break;
            case "Full":
              waitTimeHTML = `
                <span class="wait-time__time">Full for the day</span>
                ${
                  upcomingOpenTime
                    ? `
                  <span class="wait-time__text wait-time__text--reopens">${upcomingOpenTime}</span>
                `
                    : ""
                }
              `;
              break;
            default:
              /* Map Modal */
              waitTimeHTML = `
                <span class="wait-time__time">${this.gftDefault}</span>
              `;
              break;
          }

          container.innerHTML = waitTimeHTML;
        } else {
          container.innerHTML = `
                  <span class="wait-time__text eventSubtitle">${this.eventSubtitle}</span>R
                  <span class="wait-time__time">${this.eventTitle}</span>
          `;
        }
      }
    }

    // initWaitTime() {
    //   this.clearWaitTime();
    //   this.setWaitTime();
    //   this.waitTimeInterval = setInterval(this.setWaitTime.bind(this), 60000);
    // }

    // clearWaitTime() {
    //   if (this.waitTimeInterval) {
    //     clearInterval(this.waitTimeInterval);
    //   }
    // }

    openInfoWindow() {
      this.infoWindow.open(map, this.marker);
    }

    closeInfoWindow() {
      // this.clearWaitTime();
      this.infoWindow.close();
    }

    createInfoWindow() {
      const addressSplit = this.address.split(" - ").pop();

      return new google.maps.InfoWindow({
        content: `
        <div class="location" data-location="${handleize(this.name)}">
          <div class="location-heading">
            <h2 class="location__title hard">
              ${this.name}
            </h2>
            <div class="d-flex ml-auto ps-2">
              <svg class="fav-location" xmlns="http://www.w3.org/2000/svg" height="28" width="28" viewBox="0 -960 960 960">
                <path d="m480-120-58-52q-101-91-167-157T150-447.5Q111-500 95.5-544T80-634q0-94 63-157t157-63q52 0 99 22t81 62q34-40 81-62t99-22q94 0 157 63t63 157q0 46-15.5 90T810-447.5Q771-395 705-329T538-172l-58 52Z"/>
              </svg>
              <a class="" href="${this.maps_url}" target="_blank">
                <svg class="ml-2" xmlns="http://www.w3.org/2000/svg" height="28" width="28" viewBox="0 -960 960 960">
                  <path d="M480.184-486.043q31.077 0 52.707-21.532 21.631-21.531 21.631-52.609 0-31.077-21.649-52.707-21.649-21.631-52.891-21.631-31.243 0-52.591 21.649-21.348 21.649-21.348 52.891 0 31.243 21.532 52.591 21.531 21.348 52.609 21.348ZM480-170.305q130.174-117.608 192.543-210.739 62.37-93.13 62.37-172.652 0-114.809-73.794-188.013-73.794-73.204-181.034-73.204-107.241 0-181.119 73.204-73.879 73.204-73.879 188.013 0 79.522 63.87 172.37Q352.826-288.479 480-170.305Zm0 104.436Q312.217-206.826 229.043-325.456q-83.174-118.631-83.174-228.24 0-155.494 100.761-248.247Q347.392-894.696 480-894.696q132.366 0 233.531 92.753 101.165 92.753 101.165 248.247 0 109.609-83.456 228.24Q647.783-206.826 480-65.869ZM480-560Z" />
                </svg>
              </a>
            </div>
          </div>

          <div class="location__content">
            <div class="location__address">
              <address>
                ${this.short_address}
              </address>
            </div>
              <a href="tel:${
                this.phone_number
              }" class="location__phone">
                ${this.phone_number}
              </a>
            <div class="location__actions">

            <div class="wait-time__container">
            ${this.store_toggle !== false ? `
              <svg xmlns="http://www.w3.org/2000/svg" height="28" width="28" viewBox="1 -960 960 960">
                <path d="m620.782-284.739 54.609-53.479-156.173-157.303v-195.218h-72.436v224.749l174 181.251ZM480.078-65.869q-85.469 0-160.943-32.555-75.473-32.555-131.802-88.863-56.33-56.308-88.897-131.753-32.567-75.444-32.567-160.898 0-85.453 32.678-160.99 32.677-75.536 88.833-131.692 56.156-56.156 131.639-89.116T480-894.696q85.498 0 160.981 32.96 75.483 32.96 131.639 89.116 56.156 56.156 89.116 131.639T894.696-480q0 85.498-32.96 160.981-32.96 75.483-89.116 131.639-56.156 56.156-131.614 88.833-75.459 32.678-160.928 32.678ZM480-480Zm-.288 334.913q138.027 0 236.614-98.022 98.587-98.021 98.587-236.608t-98.512-236.892q-98.512-98.304-236.396-98.304-138.309 0-236.614 98.235Q145.087-618.444 145.087-480q0 138.87 98.299 236.891 98.3 98.022 236.326 98.022Z"/>
              </svg>
              <div id="WaitTime--${this.guid}" class="wait-time js-wait-time"></div>
              ` :
              `
              <div class="store-details__wait-time wait-time">
								<span class="wait-time__text">${ this.toggle_title }</span>
								<span class="wait-time__time">${ this.toggle_sub_title }</span>
							</div>
              `}
            </div>

            <div class="location__buttons">
              <a href="${this.url}" class="location__details btn btn--secondary">
                See details
              </a>
              ${this.check_in_disable === 'true' ? `
              <a
                href="tel:${this.phone_number}"
                class="modalLink btn btn--primary location__details"
                style="display: block !important;"
              >
              <svg class="icon icon--phone me-2 icons-google" width="22" height="22" fill="#fff" viewBox="0 -960 960 960" aria-hidden="true" focusable="false" role="presentation">
		        <path xmlns="http://www.w3.org/2000/svg" d="M795-113q-136-9-256.5-63T323-325q-95-94-148.5-215T112-797q-2-23 11.5-37.5T160-849h174q17 0 30 10.5t18 26.5l28 137q2 11-1.5 23t-9.5 18L293-526q19 35 43.5 68t56.5 65q29 28 60 52t63 41l115-108q7-7 14.5-9t16.5 0l147 33q17 5 28 17.5t11 29.5v176q0 23-15 36.5T795-113Z"></path>
		        <path d="M798-120q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12Z"></path></svg>
                Call to Check-In Now</a
              >
              ` :
              `
              <div class="${this.store_toggle !== false && this.check_in_url ? '' : ' hidden'}">
                <a
                  href="/pages/check-in-qr-code"
                  class="normalLink btn btn--primary location__check-in js-check-in webCheckIn">Check In</a>
              </div>
              `}
            </div>
          </div>
        </div>
        `,
      });
    }

    addMarker(map) {
      this.map = map;

      this.marker = new google.maps.Marker({
        position: this.location,
        map,
        title: this.name,
      });
      this.infoWindow = this.createInfoWindow();
      this.infoWindow.addListener("closeclick", () => {
        // this.clearWaitTime();
      });
      this.infoWindow.addListener("domready", () => {
        // this.initWaitTime();
        const infoWindow = document.querySelector('.gm-style-iw-d');

        isLocationFavorite(infoWindow);

        const shopStatusContainer = infoWindow.querySelector('.wait-time__time')

        // Select all checkin anchor elements within the InfoWindow content
        const locationPageElements = infoWindow.querySelectorAll('a.btn.btn--primary.btn-hard.store-details__check-in.check-in--link.js-check-in.webCheckIn');
        const storeLocatorElements = infoWindow.querySelectorAll('a.btn.btn--primary.location__check-in.js-check-in.webCheckIn');
        const checkInElements = locationPageElements.length > 0 ? locationPageElements : storeLocatorElements;

        // Add click event listener to each link
        // checkInElements.forEach(link => {
        //   link.addEventListener("click", function(event) {
        //     event.preventDefault();
        //     event.stopImmediatePropagation();

        //     const iframeUrl = link.getAttribute("data-url") || link.getAttribute("data-bs-url");
        //     const container = document.querySelector('div#checkInContainer');
        //     const iframe = document.querySelector('iframe#checkInFrame');

        //     iframe.setAttribute("src", iframeUrl);
        //     if (container.classList.contains('visible')) {
        //       document.body.style.overflow = "auto";
        //     } else {
        //       container.classList.add('visible');
        //       document.body.style.overflow = "hidden";
        //     }
        //   });
        // });
      });
    }
  }

  class Map {
    constructor(container) {
      this.events = {};
      this.elements = {
        map: container,
        nearestStoresList: document.querySelector(".js-nearest-stores"),
        nearestStoresCount: document.querySelector(".js-nearest-stores-count"),
        storesList:  document.querySelectorAll('.js-stores-list .location'),
        nearbyContainer: document.querySelector(".locations-nearest"),
        locationsNearestList: document.querySelector(".locations-nearest__list"),
        loader: document.querySelector(".loader")
      };

      this._location = {
        lat: 0,
        lng: 0,
      };

      this.getStores().then(() => {
        this.emit('storesReady');
      });
      this.bindEvents();

      this.listings = [];
      this.listingsNearby = [];
      this.cachedGeocodes = {};

      window.myMap = this;
    }

    on(eventName, callback) {
      if (!this.events[eventName]) {
        this.events[eventName] = [];
      }
      this.events[eventName].push(callback);
    }

    emit(eventName, ...args) {
      if (this.events[eventName]) {
        this.events[eventName].forEach(callback => callback(...args));
      }
    }

    load() {
      this.loaded = true;
      this.map = new google.maps.Map(this.elements.map, {
        center: this.userLocation,
        zoom: 15,
        styles: [
          {
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f5f5",
              },
            ],
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#f5f5f5",
              },
            ],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#bdbdbd",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: "#eeeeee",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#e5e5e5",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff",
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#dadada",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [
              {
                color: "#e5e5e5",
              },
            ],
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [
              {
                color: "#eeeeee",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#c9c9c9",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
        ],
      });

      this.setMarkers();

      if (this.geocoded || this.geolocated) {
        setTimeout(() => {
          this.updateNearestStores();
        }, 300);
      }
    }

    set userLocation(location) {
      this._location = location;
      this.updateNearestStores();
      $(".modalLink").on("click", function () {
        $("#checkinButton").attr("href", $(this).data("bs-url"));
      });
      if (this.map) {
        this.map.panTo(location);
        this.map.setZoom(11.5);
      }
    }

    get userLocation() {
      return this._location;
    }

    geocode(input) {
      const address = input.toLowerCase();

      if (address) {
        // Save some API requests if possible
        if (this.cachedGeocodes[address]) {
          this.userLocation = this.cachedGeocodes[address];
        } else {
          this.geocoder = this.geocoder || new google.maps.Geocoder();

          this.geocoder.geocode(
            {
              address: `${address}`,
            },
            (results, status) => {
              if (status == "OK") {
                const respLocation = results[0].geometry.location;
                const location = {
                  lat: respLocation.lat(),
                  lng: respLocation.lng(),
                };

                this.geocoded = true;
                this.userLocation = location;
                this.cachedGeocodes[address] = location;
              } else {
                console.warn("Geocode was not successful: " + status);
              }
            }
          );
        }
      }
    }

    async geolocate() {
      if (gmaps_geolocation) {
        if (this.cachedGeolocation) {
          this.userLocation = this.cachedGeolocation;
        } else {
          // console.log("apicall")
          const response = await fetch(
            `https://www.googleapis.com/geolocation/v1/geolocate?key=${KEY}`,
            { method: "POST" }
          );
          const { location } = await response.json();
          this.geolocated = true;
          this.cachedGeolocation = location;
          this.userLocation = location;
          // spoofs Sydney for testing
          // this.userLocation = {
          //   lat: -33.8688,
          //   lng: 151.2093,
          // };
        }
      } else {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.geolocated = true;
            this.userLocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
          },
          (error) => {
            window.console.warn("Geolocate was not successful:", error);
            document.querySelector(".js-geolocate").remove();
          }
        );
      }
    }

    staticLocations() {
      const currentLocation = this.userLocation;
      const detailsDisclosures = document.querySelectorAll('details-disclosure[data-level="child"]');


      // Function to log the data-city attribute value and distance when the details is open
      function logCityAttributeAndDistance(detailsElement) {
        const dataValue = detailsElement.getAttribute("data-city");

        // Get the <li> elements with the class "location" inside the details element
        const liElements = detailsElement.querySelectorAll(".location");

        // Loop through each <li> element and calculate the distance from this.userLocation
        liElements.forEach((liElement) => {
          const positionValue = liElement.getAttribute("data-position");

          // Check if the data-position attribute is missing
          if (!positionValue) {
            console.log(`Position value is missing for the location element in ${dataValue}`);
            return; // Optionally, you can add some logic here if needed
          }

          const [locLat, locLng] = positionValue.split(",").map(parseFloat);

          // console.log('Store lat:', locLat);
          // console.log('Store long:', locLng);
          // console.log('Current lat:', currentLocation.lat);
          // console.log('Current lng:', currentLocation.lng);

          // Log the city attribute and the distance from this.userLocation
          //console.log(`Details is open. City attribute: ${dataValue}`);
          //console.log("City Long/Lat:", locLat, locLng);
        });
      }

      // Loop through each <details-disclosure> element
      detailsDisclosures.forEach((detailsDisclosure) => {
        // Get the <details> element inside the <details-disclosure>
        const detailsElement = detailsDisclosure.querySelector("details");

        // Add event listener for the 'toggle' event on the <details> element
        detailsElement.addEventListener("toggle", function () {
          // Check if the <details> element is open
          if (this.open) {
            logCityAttributeAndDistance(this);
          } else {
            //console.log("Details is closed.");
          }
        });
      });
    }

    async getStores() {
      const response = await fetch("/blogs/news?view=json");
      const { locations } = await response.json();

      // console.log("pre-filtered",locations);
      this.stores = locations
        .filter(
          (store) =>
            store.address &&
            typeof store.address === "string" &&
            store.check_in_url &&
            store.guid &&
            store.location &&
            store.country
        )
        .map((store) => new Store(store));

      if (window.getComputedStyle(this.elements.map).display !== "none") {
        this.load();
      } else {
        window.addEventListener("resize", () => {
          if (
            window.getComputedStyle(this.elements.map).display !== "none" &&
            !this.loaded
          ) {
            this.load();
          }
        });
      }

      // this.staticLocations();
      this.geolocate();
    }

    focusStore = (store) => {
      const targetLocation = new google.maps.LatLng(store.location.lat, store.location.lng);
      //console.log('this listings:', [...this.listings], 'nearby', [...this.listingsNearby]);

      [...this.listingsNearby, ...this.listings].forEach((listing) => {
        const activeStore = Boolean(listing.store.guid === store.guid);

        listing.element.classList.toggle("is-active", activeStore);

        if (activeStore) {
          store.openInfoWindow();
        } else {
          listing.store.closeInfoWindow();
        }
      });

      if (this.map) {
        const initialLocation = this.map.getCenter();
        const bounds = new google.maps.LatLngBounds();
        bounds.extend(initialLocation);
        bounds.extend(targetLocation);

        this.map.fitBounds(bounds);

        const zoomChangeBoundsListener = google.maps.event.addListenerOnce(this.map, "bounds_changed", () => {
          if (this.map.getZoom() > 15) {
            this.map.setZoom(15);
          }
        });

        const tilesLoadedListener = google.maps.event.addListenerOnce(this.map, "tilesloaded", () => {
          google.maps.event.removeListener(zoomChangeBoundsListener);
          this.map.panTo(targetLocation);
        });

        // Remove the tiles loaded event listener after 2 seconds (adjust as needed)
        setTimeout(() => {
          google.maps.event.removeListener(tilesLoadedListener);
        }, 2000);
      }
    };

    clearNearestStores() {
      this.elements.nearestStoresList.innerHTML = "";
      this.listingsNearby.forEach((listing) => {
        listing.destroy();
      });
      this.listingsNearby = [];
    }

    updateNearestStores() {
      if (this.elements.nearbyContainer.style.display === "none") {
        $(this.elements.nearbyContainer).slideDown();
      }

      this.stores.forEach((store) => {
        store.distance = store.getDistance(this.userLocation);
      });

      const storesByDistance = this.stores
        .filter((store) => store.distance <= range)
        .sort((a, b) => a.distance - b.distance);

      const bounds = new google.maps.LatLngBounds();
      bounds.extend(this.userLocation);
      storesByDistance.forEach((store) => {
        bounds.extend(store.location);
      });

      if (this.map) {
        this.map.fitBounds(bounds);

        let zoom = Math.min(15, this.map.getZoom() - 1);
        this.map.setZoom(zoom);
      }

      this.clearNearestStores();

      if (storesByDistance.length) {
        this.listingsNearby = storesByDistance.map(
          (store, index) =>
            new Listing(store, {
              showDistance: true,
              label: index + 1,
            })
        );

        this.listingsNearby.forEach((listing, index) => {
          const label = `${index + 1}`;
          this.elements.nearestStoresList.appendChild(listing.element);
          // listing.initWaitTime();

          if (this.map) {
            listing.store.marker.setLabel(label);
          }
        });
        this.elements.loader.classList.remove('d-none');
      } else {
        this.elements.loader.classList.add('d-none');
        this.elements.nearbyContainer.classList.add('d-flex','align-items-center','w-100');
        this.elements.locationsNearestList.classList.add('w-100');
        this.elements.nearestStoresList.innerHTML = `
          <li class="locations-nearest__no-results w-100 text-center"><b>SORRY!</b> It seems there are no locations within ${range}km.</li>
        `;
      }

      this.elements.nearestStoresCount.innerHTML = ` (${storesByDistance.length})`;
    }

    setMarkers() {
      this.stores.forEach((store) => {
        store.addMarker(this.map);

        store.marker.addListener("click", () => {
          this.focusStore(store);
        });
      });
    }

    bindEvents() {
      const addressInput = document.querySelector(".js-map-search-input");
      document
        .querySelector(".js-map-search-form")
        .addEventListener("submit", (e) => {
          e.preventDefault();
          const address = addressInput.value;
          if (address) {
            this.geocode(address);
          }
        });

      document.querySelector(".js-geolocate").addEventListener("click", (e) => {
        e.preventDefault();
        this.geolocate();
      });
    }
  }

  function initMap () {
    map = new Map(document.getElementById("map"));
    map.on('storesReady', () => {
      addListenersToStaticCards(map);
    });
  }

  function loadGoogleMaps() {
    // console.log("apicall");
    var script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${KEY}&callback=initMap`;
    // script.src = `https://maps.googleapis.com/maps/api/js?key=${KEY}&callback=initMap&libraries=geometry`;
    script.async = true;

    window.initMap = initMap;

    document.head.appendChild(script);
  }

  function mapToggle() {
    const showMap = document.querySelector(".js-show-map");
    const $map = $("#map");
    let loaded = false;

    showMap.addEventListener("click", () => {
      if (!loaded) {
        $map.load();
        loaded = true;
      }

      $map.slideToggle();
      showMap.classList.toggle("is-active");
    });
  }

  // Static location cards
  function addListenersToStaticCards(map) {
    map.listings = map.stores
          .sort(({ name: a }, { name: b }) => (a < b ? -1 : 1))
          .map((store) => new Listing(store));
    const stores = map.stores
    document.querySelectorAll('.js-stores-list .location').forEach((elem, index) => {
      const shortcut_id = elem.dataset.shortcutId;
      const store = stores.find(shop => shop.shortcut_id === shortcut_id);
      if (store) {
        elem.addEventListener("click", (event) => {
          map.focusStore(store);
        });
      }
    });
  }

  window.addEventListener("load", () => {
    loadGoogleMaps();
    mapToggle();
  });
})();